<div class="planning-container">
  <mat-toolbar class="content-header">
    <h1 class="page-title">
      <mat-icon fontIcon="event_notes"></mat-icon>
      {{'planning.details'|translate}} : {{planning().name}}
    </h1>

    <!-- <app-help [link]="helpLink"></app-help> -->

    <span class="toolbar-spacer"></span>
  </mat-toolbar>

  <div class="plannings-button">
    <div class="group">
      <lib-button (click)="setZoom(-1)" icon="zoom_out" color="none" textColor="muted"
        tooltip="{{'planning.zoom_out'|translate}}">
      </lib-button>

      <lib-button (click)="setZoom(1)" icon="zoom_in" color="none" textColor="muted"
        tooltip=" {{'planning.zoom_in'|translate}}">
      </lib-button>
    </div>

    <lib-button [matMenuTriggerFor]="menu" color="muted" icon="more_horiz" tooltip="{{'planning.menu'|translate}}">
    </lib-button>

    <div class="group">
      <lib-button [matMenuTriggerFor]="display" icon="visibility" color="none" textColor="muted"
        tooltip="{{'planning.display'|translate}}">
      </lib-button>

      <lib-button [matMenuTriggerFor]="metric" icon="bar_chart" color="none" textColor="muted"
        tooltip="{{'planning.display_metric'|translate}}">
      </lib-button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="planningImport()">
        <mat-icon matMenuItemIcon>upload</mat-icon>
        {{'planning.import'|translate}}
      </button>

      <button mat-menu-item (click)="refreshFragDb()">
        <mat-icon matMenuItemIcon>refresh</mat-icon>
        {{'planning.refresh_frag_db'|translate}}
      </button>

      <button mat-menu-item (click)="setMapping()">
        <mat-icon matMenuItemIcon>schema</mat-icon>
        {{'planning.model_info'|translate}}
      </button>

      <button mat-menu-item (click)="linkFragments()">
        <mat-icon matMenuItemIcon>link</mat-icon>
        {{'planning.auto_link'|translate}}
      </button>

      <!-- <button mat-menu-item (click)="planningExport()"><mat-icon matMenuItemIcon>download</mat-icon>{{'planning.export'|translate}}</button> -->

      <button mat-menu-item (click)="runUpdate()">
        <mat-icon matMenuItemIcon>sync</mat-icon>
        {{'planning.run_update'|translate}}
      </button>

      <button mat-menu-item (click)="resetFragments()" disabled>
        <mat-icon matMenuItemIcon>restore</mat-icon>
        {{'planning.reset_frag'|translate}}
      </button>

      <!-- <button mat-menu-item (click)="updateFragments()"><mat-icon matMenuItemIcon>update</mat-icon>{{'planning.update_frag'|translate}}</button> -->

      <button mat-menu-item (click)="refreshTasks()" disabled>
        <mat-icon matMenuItemIcon>refresh</mat-icon>
        {{'planning.refresh_tasks' | translate}}
      </button>

      <div class="menu-toggle">
        <mat-slide-toggle [checked]="planningStore.showUnlinked()" (change)="updateShowUnlinked($event.checked)">
        </mat-slide-toggle>

        {{'planning.show_unlinked' | translate}}
      </div>
    </mat-menu>

    <!--  <mat-menu #columns="matMenu">
        <button mat-menu-item (click)="showColumn('text')">{{'planning.task_name'|translate}}</button>
        <button mat-menu-item (click)="showColumn('start_date')">{{'planning.date'|translate}}</button>
        <button mat-menu-item (click)="showColumn('resources')">{{'planning.resources'|translate}}</button>
        <button mat-menu-item (click)="showColumn('duration')">{{'planning.duration'|translate}}</button>
        <button mat-menu-item (click)="showColumn('cost')">{{'planning.cost'|translate}}</button>
        <button mat-menu-item (click)="showColumn('model')">{{'planning.model'|translate}}</button>
      </mat-menu> -->

    <app-planning-player [playerValue]="playerValue" (onPlayerChanged)="onPlayerChanged($event)">
    </app-planning-player>

    <!-- <div class="group realtime-btn"> <mat-slide-toggle [(ngModel)]="realtime"
        (change)="setObjectVisibility()">{{'workflows.realtime' |
        translate}}</mat-slide-toggle></div> -->

    <div class="group">
      <lib-button (click)="onShowGantt()" tooltip="Gantt" icon="assessment" color="none"
        [textColor]="showGantt() ? 'primary' : 'muted'" textColor="muted">
      </lib-button>

      <lib-button (click)="onShow3D()" tooltip="3D" icon="view_in_ar" color="none"
        [textColor]="show3D() ? 'primary' : 'muted'" textColor="muted">
      </lib-button>
    </div>

    <!-- Loading Progress -->
    <div *ngIf="isLoadingFragments() || isLoadingMetrics() || isLoadingTasks() || isLoadingModel()"
      class="group loading-fragment">
      <div *ngIf="currentLoadingLabel as label">
        <app-spinner [text]="(label | translate) + loadingProgress + '%'"></app-spinner>
      </div>

      <mat-progress-bar mode="determinate" class="loading-bar" [value]="loadingProgress"></mat-progress-bar>
    </div>

    <!-- Parsing Fragment Progress -->
    <div *ngIf="parsingFragment" class="group loading-fragment">
      <ng-container [ngSwitch]="parsingFragment">
        <div *ngSwitchCase="'frag_building'">
          <app-spinner
            [text]="('planning.loading.frag_building' | translate) + ' ' + refreshProgress + ' / ' + refreshTotal + ' (' + (refreshTotal ? ((refreshProgress / refreshTotal * 100) | number:'1.0-0') : 0) + '%)'"></app-spinner>
          <mat-progress-bar mode="determinate" class="loading-bar"
            [value]="refreshTotal ? (refreshProgress / refreshTotal) * 100 : 0">
          </mat-progress-bar>
        </div>

        <!-- Success -->
        <span *ngSwitchCase="'frag_saved'" class="success">
          <mat-icon fontIcon="account_tree"></mat-icon>
          {{ 'planning.loading.frag_saved' | translate }}
        </span>

        <!-- Error -->
        <span *ngSwitchCase="'frag_error'" class="error">
          <mat-icon fontIcon="account_tree"></mat-icon>
          {{ 'planning.loading.frag_error' | translate }}
        </span>

        <!-- Other statuses -->
        <span *ngSwitchDefault>
          {{ 'planning.loading.' + parsingFragment | translate }}
        </span>
      </ng-container>
    </div>


    <!-- Auto-Linking Progress -->
    <div *ngIf="autoLinking && autoLinkTotal > 0" class="group loading-fragment">
      <app-spinner
        [text]="('planning.loading.autolink' | translate) + ' ' + autoLinkProgress + ' / ' + autoLinkTotal + ' (' + ((autoLinkTotal ? (autoLinkProgress / autoLinkTotal) * 100 : 0) | number:'1.0-0') + '%)'">
      </app-spinner>

      <mat-progress-bar class="loading-bar" mode="determinate"
        [value]="autoLinkTotal ? (autoLinkProgress / autoLinkTotal) * 100 : 0">
      </mat-progress-bar>
    </div>

    <!-- Auto-Linking Done -->
    <div *ngIf="autoLinkDone" class="group success-fragment">
      <mat-icon fontIcon="link"></mat-icon>
      {{ 'planning.loading.autolink_done' | translate }}
    </div>

    <!-- Planning Recalculation Progress -->
    <div *ngIf=" updatingPlanning && updateTotal> 0" class="group loading-fragment">
      <app-spinner
        [text]="('planning.loading.planning_recalculation' | translate) + ' ' + updateProgress + ' / ' + updateTotal + ' (' + ((updateProgress / updateTotal) * 100 | number:'1.0-0') + '%)'"></app-spinner>

      <mat-progress-bar class="loading-bar" mode="determinate" [value]="(updateProgress / updateTotal) * 100">
      </mat-progress-bar>
    </div>
  </div>

  <div #content id="global">
    <app-planning-view #planningView class="planning-view" [width]="ganttWidth"
      [showUnlinked]="planningStore.showUnlinked" (onCurrentTaskChanged)="onCurrentTaskChanged($event)"
      [style.width]="ganttWidth() + 'px'">
    </app-planning-view>

    <div #resize *ngIf="show3D() && showGantt()" class="resize-handler" id="resize-handler"
      [style.left]="ganttWidth() + 'px'">
    </div>

    <app-viewer #viewer id="planning-viewer" [style.left]="ganttWidth() + 'px'"
      [style.width]="(contentWidth - ganttWidth()) + 'px'" [model]="model" [project]="project" [user]="user"
      [startDate]="startDate" [endDate]="endDate" (onTaskSelected)="onTaskSelected($event)"
      (onLoaded3D)="onLoaded3D($event)">
    </app-viewer>

    <app-task-info #sideinfo [model]="model()" [units]="units" (onTaskChanged)="onTaskChanged($event)"
      (onMetricSelected)="onMetricSelected($event)" *ngIf="currentTask()" (onClose)="closeSideBar()">
    </app-task-info>
  </div>

  <input type="file" accept='text/xml' style="display:none" id="planning-file-input" #planningFileInput
    (change)="uploadPlanningXML($event)">
</div>

<!-- Display Options Menu -->
<mat-menu #display="matMenu">
  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().late" (change)="onToggleDisplayModel('late', $event)"
      (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().late ? 'active late' : ''">
        <mat-icon fontIcon="trending_down"></mat-icon>
        {{'planning.show_late' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().ahead" (change)="onToggleDisplayModel('ahead', $event)"
      (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().ahead ? 'active ahead' : ''">
        <mat-icon fontIcon="trending_up"></mat-icon>
        {{'planning.show_ahead' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().todo" (change)="onToggleDisplayModel('todo', $event)"
      (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().todo ? 'active todo' : ''">
        <mat-icon fontIcon="task_alt"></mat-icon>
        {{'planning.show_todo' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().progress"
      (change)="onToggleDisplayModel('progress', $event)" (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().progress ? 'active progress' : ''">
        <mat-icon fontIcon="autorenew"></mat-icon>
        {{'planning.show_progress' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().done" (change)="onToggleDisplayModel('done', $event)"
      (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().done ? 'active done' : ''">
        <mat-icon fontIcon="done_all"></mat-icon>
        {{'planning.show_done' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayModel().unused" (change)="onToggleDisplayModel('unused', $event)"
      (click)="$event.stopPropagation()">
      <div class="textMenu" [ngClass]="planningStore.displayModel().unused ? 'active unused' : ''">
        <mat-icon fontIcon="block"></mat-icon>
        {{'planning.show_unused' | translate}}
      </div>
    </mat-slide-toggle>
  </div>
</mat-menu>

<!-- Metric Display Menu -->
<mat-menu #metric="matMenu">
  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['concreting']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('concreting', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['concreting'] ? 'active-concreting' : ''">
        <mat-icon fontIcon="water_drop"></mat-icon>
        {{'planning.concreting' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['formwork']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('formwork', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['formwork'] ? 'active-formwork' : ''">
        <mat-icon fontIcon="space_dashboard"></mat-icon>
        {{'planning.formwork' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['reinforcement']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('reinforcement', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['reinforcement'] ? 'active-reinforcement' : ''">
        <mat-icon fontIcon="grid_3x3"></mat-icon>
        {{'planning.reinforcement' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['precast_slab']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('precast_slab', $event)">

      <div class="textMenu" [ngClass]="planningStore.displayMetric()['precast_slab'] ? 'active-precast_slab' : ''">
        <mat-icon fontIcon="layers"></mat-icon>
        {{'planning.precast_slab' | translate}}
      </div>

    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['beam']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('beam', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['beam'] ? 'active-beam' : ''">
        <mat-icon fontIcon="horizontal_rule"></mat-icon>
        {{'planning.beam' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['wall']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('wall', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['wall'] ? 'active-wall' : ''">
        <mat-icon fontIcon="crop_16_9"></mat-icon>
        {{'planning.wall' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['column']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('column', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['column'] ? 'active-column' : ''">
        <mat-icon fontIcon="horizontal_rule" style="transform: rotate(90deg);"></mat-icon>
        {{'planning.column' | translate}}
      </div>
    </mat-slide-toggle>
  </div>

  <div class="menu-toggle">
    <mat-slide-toggle [checked]="planningStore.displayMetric()['other']" (click)="$event.stopPropagation()"
      (change)="onToggleDisplayMetric('other', $event)">
      <div class="textMenu" [ngClass]="planningStore.displayMetric()['other']  ? 'active-other' : ''">
        <mat-icon fontIcon="help_outline"></mat-icon>
        {{'planning.other' | translate}}
      </div>
    </mat-slide-toggle>
  </div>
</mat-menu>